import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OUTRO_HINT_SCREEN_DURATION } from "../utils/constants";
const Outro = () => {
  const navigate = useNavigate();
  useEffect(() => {
    let timeout: any;
    timeout = setTimeout(() => {
      navigate("/");
    }, OUTRO_HINT_SCREEN_DURATION);
    return () => {
      timeout && clearTimeout(timeout);
    };
  }, []);

  return (
    <section className="outro-container">
      <img src="/assets/ending.png" alt="ending background" className="bg" />
      <footer>
        <img
          src="/assets/ending-logo.png"
          alt="ending logo "
          className="logo"
        />
      </footer>
    </section>
  );
};

export default Outro;
